import { APP_ENV } from '../../config/setting';
import { storeDispatch } from '../../redux/store';
import { updateRemoteConfigValues } from '../store/actions';
import RemoteConfigRequestService from './RemoteConfigRequestService';

export default class RemoteConfigService {
    private remoteConfigPoller: any;

    constructor() {
    }

    initialize() {
        this.setRemoteConfigPoller();
    }

    clearRemoteConfigPoller() {
        clearInterval(this.remoteConfigPoller);
    }

    async fetchAndApplyRemoteConfig(): Promise<void> {
        try {
            /**
             * this is pulled from org_app_map
             */
            const remoteConfigResponse = await RemoteConfigRequestService.fetchRemoteConfig({});
            const remoteConfigs = remoteConfigResponse.data;
            storeDispatch(updateRemoteConfigValues(remoteConfigs));
        } 
        catch (e) {
            // ErrorHandlerService.handleError(e, {
            //     openToast: false,
            // });
        }
    }

    setRemoteConfigPoller() {
        const timeout = APP_ENV === 'prod'
            ? 1000 * 60 * 10 // 10 mins
            : 1000 * 60 * 5 // 5 min
        ;

        this.fetchAndApplyRemoteConfig().finally(() => {
            this.clearRemoteConfigPoller();
            this.remoteConfigPoller = setTimeout(() => {
                this.setRemoteConfigPoller();
            }, timeout);
        });
    }
}
